"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var Box_1 = __importDefault(require("@mui/material/Box"));
var i18next_1 = __importDefault(require("i18next"));
var home_bravas_en_svg_1 = __importDefault(require("./images/home-bravas-en.svg"));
var home_bravas_fr_svg_1 = __importDefault(require("./images/home-bravas-fr.svg"));
var homeBravas = {
    fr: home_bravas_fr_svg_1.default,
    en: home_bravas_en_svg_1.default,
};
function BravasIllustration() {
    return ((0, jsx_runtime_1.jsx)(Box_1.default, { sx: {
            ml: {
                xs: 3,
                xl: 4,
            },
            mt: {
                xs: 3,
                xl: 4,
            },
        }, component: "img", src: homeBravas[i18next_1.default.resolvedLanguage] || home_bravas_en_svg_1.default, width: "564px", alt: "Bravas Illustration" }));
}
exports.default = BravasIllustration;
//# sourceMappingURL=BravasIllustration.js.map